import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "settings-view" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { class: "settings-section" }
const _hoisted_4 = { class: "info-grid" }
const _hoisted_5 = { class: "info-item" }
const _hoisted_6 = {
  key: 0,
  class: "info-item"
}
const _hoisted_7 = { class: "info-value" }
const _hoisted_8 = {
  key: 1,
  class: "info-item"
}
const _hoisted_9 = { class: "info-value" }
const _hoisted_10 = {
  key: 2,
  class: "info-item"
}
const _hoisted_11 = { class: "info-value" }
const _hoisted_12 = {
  key: 3,
  class: "info-item"
}
const _hoisted_13 = { class: "token-display" }
const _hoisted_14 = { class: "settings-section" }
const _hoisted_15 = { class: "info-grid" }
const _hoisted_16 = { class: "info-item" }
const _hoisted_17 = {
  key: 0,
  class: "info-item"
}
const _hoisted_18 = { class: "token-display" }
const _hoisted_19 = { class: "settings-section" }
const _hoisted_20 = { class: "info-grid" }
const _hoisted_21 = { class: "info-item" }
const _hoisted_22 = { class: "info-item" }
const _hoisted_23 = { class: "info-item" }
const _hoisted_24 = {
  key: 0,
  class: "info-item"
}
const _hoisted_25 = { class: "token-display" }
const _hoisted_26 = { class: "settings-section" }
const _hoisted_27 = { class: "action-buttons" }

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useSpotifyAuth } from '@/composables/useSpotifyAuth';
import { useSpotifyPlayer } from '@/composables/useSpotifyPlayer';
import { useDeviceOrientation } from '@/composables/useDeviceOrientation';
import SpotifyStatusBadge from '@/components/Spotify/SpotifyStatusBadge.vue';
import PrimaryButton from '@/components/UI/PrimaryButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {

const router = useRouter();

const { 
  accessToken, 
  userProfile, 
  isPremium, 
  isAuthenticated, 
  logout 
} = useSpotifyAuth();

const { 
  deviceId, 
  isReady,
  connect 
} = useSpotifyPlayer();

const {
  isFaceDown,
  beta,
  isSupported,
  permissionGranted,
  requestPermission
} = useDeviceOrientation();

const truncatedToken = computed(() => {
  if (!accessToken.value) return 'Nicht vorhanden';
  return `${accessToken.value.substring(0, 20)}...`;
});

async function connectPlayer() {
  await connect();
}

async function requestOrientationPermission() {
  await requestPermission();
}

function handleLogout() {
  logout();
  router.push('/');
}

function goHome() {
  router.push('/');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "settings-header" }, [
        _createElementVNode("h1", null, "⚙️ Einstellungen & Debug")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Spotify-Verbindung", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "info-label" }, "Status:", -1)),
            _createVNode(SpotifyStatusBadge)
          ]),
          (_unref(userProfile))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "info-label" }, "Benutzer:", -1)),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(userProfile).display_name), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(userProfile))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "info-label" }, "E-Mail:", -1)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(userProfile).email), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(userProfile))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "info-label" }, "Produkt:", -1)),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(userProfile).product), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(accessToken))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "info-label" }, "Access Token:", -1)),
                _createElementVNode("code", _hoisted_13, _toDisplayString(truncatedToken.value), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[9] || (_cache[9] = _createElementVNode("h2", null, "Web Playback SDK (Premium)", -1)),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "info-label" }, "Player bereit:", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(['status-badge', _unref(isReady) ? 'status-success' : 'status-error'])
            }, _toDisplayString(_unref(isReady) ? '✓ Ja' : '✕ Nein'), 3)
          ]),
          (_unref(deviceId))
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "info-label" }, "Device ID:", -1)),
                _createElementVNode("code", _hoisted_18, _toDisplayString(_unref(deviceId)), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(isPremium) && !_unref(isReady))
          ? (_openBlock(), _createBlock(PrimaryButton, {
              key: 0,
              onClick: connectPlayer,
              size: "sm"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" Player verbinden ", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _cache[15] || (_cache[15] = _createElementVNode("h2", null, "Geräte-Orientierung", -1)),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "info-label" }, "Unterstützt:", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(['status-badge', _unref(isSupported) ? 'status-success' : 'status-error'])
            }, _toDisplayString(_unref(isSupported) ? '✓ Ja' : '✕ Nein'), 3)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "info-label" }, "Berechtigung:", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(['status-badge', _unref(permissionGranted) ? 'status-success' : 'status-error'])
            }, _toDisplayString(_unref(permissionGranted) ? '✓ Erteilt' : '✕ Nicht erteilt'), 3)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "info-label" }, "Face Down:", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(['status-badge', _unref(isFaceDown) ? 'status-success' : 'status-neutral'])
            }, _toDisplayString(_unref(isFaceDown) ? '✓ Ja' : '— Nein'), 3)
          ]),
          (_unref(beta) !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "info-label" }, "Beta (Neigung):", -1)),
                _createElementVNode("code", _hoisted_25, _toDisplayString(_unref(beta).toFixed(2)) + "°", 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_unref(permissionGranted))
          ? (_openBlock(), _createBlock(PrimaryButton, {
              key: 0,
              onClick: requestOrientationPermission,
              size: "sm"
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode(" Berechtigung anfordern ", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _cache[18] || (_cache[18] = _createElementVNode("h2", null, "Aktionen", -1)),
        _createElementVNode("div", _hoisted_27, [
          (_unref(isAuthenticated))
            ? (_openBlock(), _createBlock(PrimaryButton, {
                key: 0,
                variant: "secondary",
                onClick: handleLogout
              }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createTextVNode(" Von Spotify trennen ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(PrimaryButton, {
            variant: "ghost",
            onClick: goHome
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode(" Zurück zur Startseite ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})